import React, { useEffect } from 'react';
import './campos-item-galeria.component.scss';
import { Button, FormControlLabel, TextField } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { ItemMenusModel, ItensComIconesModel } from '../../models/footer.model';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { CONSTANTS } from '../../constants/constants';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import { ItensCarrossel } from '../../models/carrossel.model';
import AttachmentModalComponent from '../attachment-modal/attachment-modal.component';
import { ItensGaleria } from '../../models/galeria.model';

type CamposItemGaleriaComponentProps = {
  setVal: (val: any) => void;
  removeItem: (id?: string) => void;
  itemGaleria?: ItensGaleria;
  index?: number;
}

function CamposItemGaleriaComponent(props: CamposItemGaleriaComponentProps) {
  const [srcInput, setSrcInput] = React.useState(props.itemGaleria ? props.itemGaleria.src : '');
  const [widthInput, setWidthInput] = React.useState(props.itemGaleria ? props.itemGaleria.width : '');
  const [heightInput, setHeightInput] = React.useState(props.itemGaleria ? props.itemGaleria.height : '');

  SalvarPainelService.getSalvar().subscribe(() => {
    handleChangeItem();
  });

  const handleChangeItem = () => {
    props.setVal({
      id: props.itemGaleria?.id,
      src: srcInput,
      width: widthInput,
      height: heightInput
    });
  };

  return (
    <section className="campos-item-galeria">
      <div className="campo w50">
        <AttachmentModalComponent setVal={(attachFile) => setSrcInput(attachFile.src)} file={{ id: '', src: srcInput }} legenda='Imagem' />
      </div>

      <div className="bts">
        <Button className='bt remove' onClick={() => props.removeItem(props.itemGaleria?.id)}><DeleteIcon /> Remover item</Button>
      </div>
    </section>
  );
}

export default CamposItemGaleriaComponent;
